import { v4 as uuid } from 'uuid';
export function setupDefaultChoices(blankText) {
  var defaultChoices = {
    scoringData: {
      value: null,
      blankText: blankText
    },
    choices: [{
      id: uuid(),
      position: 1,
      itemBody: ''
    }, {
      id: uuid(),
      position: 2,
      itemBody: ''
    }, {
      id: uuid(),
      position: 3,
      itemBody: ''
    }]
  };
  var choice = defaultChoices.choices.find(function (choice) {
    return choice.position === 1;
  });
  choice.itemBody = blankText;
  defaultChoices.scoringData.value = choice.id;
  return defaultChoices;
}
export function setupDefaultEditDistance(blankText) {
  return {
    value: blankText,
    editDistance: 1,
    ignoreCase: false,
    blankText: blankText
  };
}
export function setupDefaultSpecifiedAnswers(blankText) {
  return {
    value: [blankText, ''],
    blankText: blankText
  };
}